import { Authority } from '@/shared/security/authority';

const venitUserMenuPageComponent = () => import('@/venit/user/menu-page/menu-page.vue');
const venitUserOrderPageComponent = () => import('@/venit/components/cortona-venit/components/orders/OrderPage.vue');
const venitUserSearchPageComponent = () => import('@/venit/user/search/search-page.vue');
const venitUserOrdersPageComponent = () => import('@/venit/user/orders/user-orders-page.vue');

export default [

  {
    path: '/user/page/:menuId',
    name: 'user-menu-page',
    component: venitUserMenuPageComponent,
    meta: { authorities: [Authority.ORGANIZATION_USER, Authority.ADMIN] },
  },

  {
    path: '/user/order',
    name: 'user-order-page',
    component: venitUserOrderPageComponent,
    meta: { authorities: [Authority.ORGANIZATION_USER, Authority.ADMIN] },
  },

  {
    path: '/user/search',
    name: 'user-search-page',
    component: venitUserSearchPageComponent,
    meta: { authorities: [Authority.ORGANIZATION_USER, Authority.ADMIN] },
  },

  {
    path: '/user/orders',
    name: 'user-orders-page',
    component: venitUserOrdersPageComponent,
    meta: { authorities: [Authority.ORGANIZATION_USER, Authority.ADMIN] },
  },

];
